import { cn } from "@/lib/utils";

export const adminOverlay = (z = "z-50") =>
  cn(
    "fixed inset-0 flex items-center justify-center p-4 max-lg:p-0 bg-black/80 backdrop-blur-sm",
    z,
  );

export const adminDialogPanel = (maxWidth = "max-w-3xl") =>
  cn(
    "bg-[#0a0a0a] border border-white/10 w-full overflow-y-auto max-h-[90vh]",
    "max-lg:max-h-none max-lg:h-[100dvh] max-lg:border-0",
    maxWidth,
    "max-lg:max-w-none",
  );

export const adminIconBtn =
  "inline-flex items-center justify-center min-h-11 min-w-11 p-2 text-white/70 hover:text-white hover:bg-white/10 transition-colors";

export const adminInput =
  "w-full bg-white/5 border border-white/10 text-white px-4 py-3 font-['Manrope'] focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50";
